import React from 'react';

import CoinGecko from '../../Icons/coingecko.jsx';
import Discord from '../../Icons/discord.jsx';
import Documentation from '../../Icons/documentation.jsx';
import Etherscan from '../../Icons/etherscan.jsx';
import ExternalLink from '../../Icons/external-link.jsx';
import Github from '../../Icons/github.jsx';
import Instagram from '../../Icons/instagram.jsx';
import OpenSea from '../../Icons/opensea.jsx';
import Twitter from '../../Icons/twitter.jsx';
import Website from '../../Icons/website.jsx';

var DefaultIcon = ExternalLink;

// a dictionary containing common domain names, and the link titles and icons
// that should be used.
var DomainIcons = {
  'discord.com': { Icon: Discord, title: 'Discord' },
  'discord.gg': { Icon: Discord, title: 'Discord' },
  'github.com': { Icon: Github, title: 'GitHub' },
  'twitter.com': { Icon: Twitter, title: 'Twitter' }
};

// same idea as the DomainIcons, but this time for the link type.
var TypeIcons = {
  'coingecko':  { Icon: CoinGecko, title: 'CoinGecko' },
  'documentation':  { Icon: Documentation, title: 'Documentation' },
  'etherscan':  { Icon: Etherscan, title: 'Etherscan' },
  'instagram':  { Icon: Instagram, title: 'Instagram' },
  'opensea':  { Icon: OpenSea, title: 'OpenSea' },
  'website':  { Icon: Website, title: 'Website' }
};


class AssetsLinks extends React.Component {
  render() {
    var links = [];
    for (var i = 0; i < this.props.links.length; i++) {
      var link = this.props.links[i];

      links.push(this.formatLink(link));
    }

    return (
      <nav className="cs-assets-links">
        {links}
      </nav>
    );
  }

  formatLink(link) {
    var type = link.type;
    var url = new URL(link.url);

    var Icon = DefaultIcon;
    var title = url.host;

    // if the domain is one of the special known ones, use that icon instead.
    if (DomainIcons.hasOwnProperty(url.host)) {
      Icon = DomainIcons[url.host].Icon;
      title = DomainIcons[url.host].title;
    } else {
      if (TypeIcons.hasOwnProperty(type)) {
        Icon = TypeIcons[type].Icon;
        title = TypeIcons[type].title;
      }
    }


    return (
      <a key={type} href={link.url} target="_blank" className="cs-assets-links__item">
        <Icon />
        <span>{title}</span>
      </a>
    );
  }
}


export default AssetsLinks;

